import { render, staticRenderFns } from "./AccountSellerDocumentField.vue?vue&type=template&id=3864aa8f&scoped=true"
import script from "./AccountSellerDocumentField.vue?vue&type=script&lang=js"
export * from "./AccountSellerDocumentField.vue?vue&type=script&lang=js"
import style0 from "./AccountSellerDocumentField.vue?vue&type=style&index=0&id=3864aa8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864aa8f",
  null
  
)

export default component.exports